import { getLoginInfo } from "../auth/getLoginInfo";
import { createAxios, createAxiosWithToken } from "./createAxios";

export async function GetAll() {
    return await createAxios().get("/State/GetAll")
}

export async function GetById(param) {
    return await createAxios().get("/State/GetById?Id=" + param.Id)
}

export async function Add(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/State/Add", param)
}

export async function Edit(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/State/Edit", param)
}

export async function Remove(id) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/State/Remove?Id=" + id)

}